import axios from 'axios'

export default {
    getClaims(page) {
        return axios.get('/api/dashboard/claims',
            {
                params: {
                    page: page
                }
            });
    },
    getClaimsForSearch(text) {
        return axios.get('/api/claims',
            {
                params: {
                    q: text
                }
            });
    },
    getPartsForSearch(text) {
        return axios.get('/api/dashboard/orders/search',
            {
                params: {
                    partOrderNumber: text
                }
            });
    },
    getServiceTicketsForSearch(text) {
        return axios.get('/api/dashboard/servicetickets/search',
            {
                params: {
                    serviceTicketName: text
                }
            });
    },
    getOrders(page) {
        return axios.get('/api/dashboard/orders',
            {
                params: {
                    page: page
                }
            });
    },
    getClaimsCategories() {
        return axios.get('/api/dashboard/categories/claims');
    },
    getServiceTicketsCategories() {
        return axios.get('/api/dashboard/categories/servicetickets');
    },
    getPartOrdersCategories() {
        return axios.get('/api/dashboard/categories/partorders');
    },
    deleteClaim(id) {
        return axios.delete(`/api/claims/${id}`);
    },
    getRMAs(page) {
        return axios.get('/api/dashboard/rmas',
            {
                params: {
                    page: page
                }
            });
    },
    getRMAsForSearch(text) {
        return axios.get('/api/dashboard/rmas/search',
            {
                params: {
                    rmaNumber: text
                }
            });
    },
    deleteRMA(id) {
        return axios.delete(`/api/rmas/${id}`);
    },
}



// WEBPACK FOOTER //
// ./ClientApp/app/dashboard/api.js